import { capitalize } from 'lodash';

import {
  findAppointmentStatusColor,
  findAppointmentStatusLabel,
  formatDateAndTime,
  mString
} from 'lib/helpers/utility';

import Badge from 'components/shared/Badge/Badge';

export default function getDefaultColumns(appointmentStatuses, timezone) {
  return [
    {
      field: 'practitioner.fullName',
      headerName: 'Practitioner',
      valueFormatter: ({ value }) => capitalize(value),
      minWidth: 170,
      flex: 1,
      sortable: false
    },
    {
      field: 'invoice.procedures_label',
      headerName: 'Services',
      valueFormatter: ({ value }) => capitalize(value),
      flex: 1,
      minWidth: 170,
      sortable: false
    },
    {
      field: 'invoice.balance',
      headerName: 'Balance',
      valueFormatter: ({ value }) => mString(value),
      minWidth: 170,
      flex: 1,
      sortable: false
    },
    {
      field: 'status',
      headerName: 'Status',
      width: 100,
      cellRenderer: (params) => (
        <div className="flex h-full w-full items-center">
          <Badge
            text={findAppointmentStatusLabel(appointmentStatuses, params.value)}
            color={findAppointmentStatusColor(appointmentStatuses, params.value)}
          />
        </div>
      ),
      flex: 1
    },
    {
      field: 'starts_at',
      headerName: 'Date',
      valueFormatter: ({ value }) => formatDateAndTime(value, timezone),
      minWidth: 170,
      flex: 1,
      sortable: false
    }
  ];
}
